// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.725 17.8"><path d="M17.425 16.1l-4.9-4.9a6.9 6.9 0 00-.7-9.1 6.662 6.662 0 00-4.9-2.1 6.662 6.662 0 00-4.9 2.1 7.063 7.063 0 000 9.9 6.966 6.966 0 004.9 2 7.294 7.294 0 004.2-1.4l4.9 4.9a.967.967 0 001.4 0 .967.967 0 000-1.4zm-14-5.6a5.134 5.134 0 010-7.1 5 5 0 013.5-1.4 4.691 4.691 0 013.5 1.5 5.289 5.289 0 011.5 3.5 4.691 4.691 0 01-1.5 3.5 5.289 5.289 0 01-3.5 1.5 4.691 4.691 0 01-3.5-1.5z"/></svg>
);

export default fn;
